import React, { Component } from "react";
/* import Link from '@material-ui/core/Link'; */
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
/* import Input from '@material-ui/core/Input'; */
import Button from "./components/Custom/Button/Button";
import ApiService from "./ApiService";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import { Alert, Autocomplete, TextField } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const useStyles = (theme) => ({
  searchbar: {
    margin: theme.spacing(2),
  },
  root: {
    height: 500,
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
  formControl: {
    marginLeft: 20,
    minWidth: 120,
    maxWidth: 300,
  },
});

class CardWhitelistComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchantId: null,
      selectedFile: null,
      failed: false,
      responsemessage: null,
      success: false,
      merchants: [],
      agents: [],
      selectedMerchant: null,
      selectedAgent: null,
      label: null,
      fileName: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.onFileChangeHandler = this.onFileChangeHandler.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.fetchAllMerchants = this.fetchAllMerchants.bind(this);
    this.fetchAllMerchants();
    this.fetchAllAgents = this.fetchAllAgents.bind(this);
    this.fetchAllAgents();
  }
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleMerchantChange = (event, newValue) => {
    this.setState({
      selectedMerchant: newValue ? newValue.id : null,
      selectedAgent: null,
    });
  };
  handleAgentChange = (event, newValue) => {
    this.setState({
      selectedAgent: newValue ? newValue.resellerId : null,
      selectedMerchant: null,
    });
  };

  fetchAllMerchants() {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
    });
  }
  fetchAllAgents() {
    ApiService.fetchAllAgents().then((res) => {
      this.setState({ agents: res.data });
    });
  }
  onFileChangeHandler = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    this.setState({
      failed: false,
      success: false,
      selectedFile: file,
      fileName: file ? file.name : "", // Store the file name if a file is selected
    });
  };

  uploadFile() {
    this.setState({ success: false, failed: false });
    const formData = new FormData();
    formData.append("files", this.state.selectedFile);
    {
      this.state.selectedMerchant &&
        formData.append("cardMerchant", this.state.selectedMerchant);
    }
    {
      this.state.selectedAgent &&
        formData.append("cardAgent", this.state.selectedAgent);
    }
    ApiService.uploadCardWhitelist(formData)
      .then((res) => {
        if (res.data.status === "OK") {
          this.setState({
            success: true,
            responsemessage: res.data.responseMessage,
            selectedFile: null,
            fileName: "",
          });
        } else {
          this.setState({
            failed: true,
            responsemessage: res.data.responseMessage,
            fileName: "",
          });
        }
      })
      .catch((e) => {
        this.setState({ failed: true, responsemessage: e });
      });
  }
  MenuProps = {
    PaperProps: {
      style: {
        maxHeight: this.ITEM_HEIGHT * 4.5 + this.ITEM_PADDING_TOP,
        width: 380,
      },
    },
  };

  render() {
    const { classes } = this.props;
    const { selectedMerchant, merchants, selectedAgent, agents } = this.state;
    //const {} = this.state;
    return (
      <React.Fragment>
        <Paper style={{ margin: "1em", padding: "1em", minHeight: 400 }}>
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            Whitelist Cards
          </Typography>
          <Divider light className={classes.searchbar} />
          {this.state.failed && (
            <Alert severity="error" elevation="0">
              {" "}
              {this.state.responsemessage}
            </Alert>
          )}
          {this.state.success && (
            <Alert severity="success" elevation="0">
              {" "}
              {this.state.responsemessage}{" "}
            </Alert>
          )}
          &nbsp;
          {/* <Grid container spacing={1} style={{ paddingBottom: 50 }}>
            <Grid>
              <FormControl className={classes.formControl}>
                <InputLabel id="merchantSelectLabel">
                  Select Merchant
                </InputLabel>
                <Select
                  value={this.state.selectedMerchant}
                  style={{ width: 350 }}
                  onChange={this.handleChange}
                  name="selectedMerchant"
                  labelId="merchantSelectLabel"
                  id="merchantTerminalSelect"
                >
                  <MenuItem key="" value="">
                    &nbsp;{" "}
                  </MenuItem>
                  {this.state.merchants &&
                    this.state.merchants.map((m) => (
                      <MenuItem key={m.id} value={m.id} dense>
                        {m.merchantName + "-" + m.code}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid> */}
          <Grid container spacing={2} style={{ paddingBottom: 50 }}>
            <Grid item>
              <Autocomplete
                value={
                  merchants.find(
                    (merchant) => merchant.id === selectedMerchant
                  ) || null
                }
                onChange={this.handleMerchantChange}
                sx={{ width: 250 }}
                options={merchants}
                getOptionLabel={(option) =>
                  option ? option.merchantName + "-" + option.code : ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Merchant"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item>
              <Autocomplete
                value={
                  agents.find((agent) => agent.resellerId === selectedAgent) ||
                  null
                }
                onChange={this.handleAgentChange}
                sx={{ width: 250 }}
                options={agents}
                getOptionLabel={(option) => (option ? option.username : "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Agent"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          </Grid>
          <Box
            style={{
              width: "100%",
              height: 300,
              borderRadius: "10px",
              border: "2px dashed #4caf50",
              backgroundColor: "#f0f0f0",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              position: "relative",
              transition: "all 0.3s ease-in-out",
              textAlign: "center",
              padding: "20px",
            }}
            className="upload-box"
          >
            <label
              htmlFor="file"
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                position: "relative",
                zIndex: 1,
                fontFamily: "'Roboto', sans-serif",
                cursor: "pointer",
              }}
            >
              <input
                type="file"
                id="file"
                name="file"
                onChange={this.onFileChangeHandler}
                style={{
                  opacity: 0,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
              />

              {/* Upload Icon */}
              <CloudUploadIcon
                style={{
                  fontSize: 50,
                  color: "#4caf50",
                  marginBottom: "10px",
                }}
              />

              <Typography
                variant="h6"
                style={{
                  color: "#4caf50",
                  fontWeight: "bold",
                  fontSize: "20px",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  transition: "all 0.3s ease",
                }}
              >
                {this.state.fileName
                  ? this.state.fileName
                  : "Click or drag a file here"}
              </Typography>
            </label>
          </Box>
          <Grid justify="center" alignItems="center" container xs={12}>
            <Grid item xs={2}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                onClick={this.uploadFile}
                style={{ marginTop: "20px" }}
              >
                Upload
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}
export default withStyles(useStyles)(CardWhitelistComponent);
